<template>
  <ReadOnlyItem v-if="disabled" :gray="gray" label="Manufacturer" :value="selectedManufacturer?.name" />
  <InlineTypeaheadModal
    v-else
    :clearable="false"
    clear-search-on-dismiss
    :gray="gray"
    :state="state"
    :errors="errors"
    v-model="selectedManufacturer"
    title="Manufacturer"
    label-key="name"
    :get-options="getOptions"
    :compare-with="compareWith"
  ></InlineTypeaheadModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { MeterManufacturerModel, UtilityFamily } from '@ncss/models/dist/v3';
import { useMeterManufacturers } from '@/composables/use-meter-manufacturers';
import { FormControlError, FormControlState } from '@/composables/use-form-control';
import InlineTypeaheadModal from '../typeahead/InlineTypeaheadModal.vue';
import ReadOnlyItem from '../ReadOnlyItem.vue';

const props = defineProps<{
  utilityFamily: UtilityFamily;
  gray?: boolean;
  state?: FormControlState;
  errors?: FormControlError[];
  disabled?: boolean;
}>();
const { search, findById } = useMeterManufacturers(() => props.utilityFamily);
const vModel = defineModel({ type: Number });
const selectedManufacturer = ref<MeterManufacturerModel>();

function getOptions(text?: string): Promise<MeterManufacturerModel[]> {
  return search(text);
}

function compareWith(a: any, b: any) {
  return a?._id === b?._id;
}

watch(selectedManufacturer, (val) => {
  vModel.value = val?._id;
});

watch(
  vModel,
  async (val) => {
    if (val !== selectedManufacturer.value?._id) {
      selectedManufacturer.value = val ? await findById(val) : undefined;
    }
  },
  { immediate: true }
);

defineExpose({
  selectedManufacturer,
});
</script>

<style scoped></style>
